import React from 'react';
import { FormattedNumber } from 'react-intl';
import { useTranslate } from '../../mixins/translate/translate';
import { Roles } from '../../utils/enums/Roles';
import {
    EditPanelButton,
    EditPanelButtons,
    EditPanelCell,
    EditPanelRow,
    LeftTrayItem,
    LeftTrayList,
    PanelBodyHeading,
    PanelWithoutForm,
} from '../elements';
import { IMaintenanceMeasure } from '../interfaces/IMaintenanceMeasure';
import RoleDependent from '../utils/RoleDependent';
import { UnitOfMeasurement } from '../utils/UnitOfMeasurement';

export function MaintenancePopupDetails(props: {
    maintenanceMeasure: IMaintenanceMeasure;
    onClose: () => void;
    setImplementationYear: (maintenanceMeasureId: string) => void;
}) {
    const translate = useTranslate();

    return (
        <PanelWithoutForm>
            <PanelBodyHeading text={props.maintenanceMeasure.description}>
                <EditPanelRow>
                    <EditPanelCell rowCount={12}>
                        <LeftTrayList>
                            {(props.maintenanceMeasure.maintenanceType && (
                                <LeftTrayItem title={translate('common.type')}>{props.maintenanceMeasure.maintenanceType}</LeftTrayItem>
                            )) || (
                                <LeftTrayItem title={translate('common.type')}>{translate('maintenanceMeasure.correctiveMaintenance')}</LeftTrayItem>
                            )}
                            <LeftTrayItem title={translate('common.cost')}>
                                <FormattedNumber value={props.maintenanceMeasure.cost ?? 0} style="currency" currency="EUR" />{' '}
                            </LeftTrayItem>
                            {props.maintenanceMeasure.implementationYear && (
                                <LeftTrayItem title={translate('maintenanceMeasure.implementationYear')}>
                                    {props.maintenanceMeasure.implementationYear}
                                </LeftTrayItem>
                            )}
                            <LeftTrayItem title={translate('maintenanceMeasure.cycle')}>{props.maintenanceMeasure.cycle}</LeftTrayItem>
                            <LeftTrayItem title={translate('maintenanceMeasure.year')}>{props.maintenanceMeasure.planYear}</LeftTrayItem>
                            <LeftTrayItem title={translate('maintenanceMeasure.finalPlanYear')}>
                                {props.maintenanceMeasure.finalPlanYear}
                            </LeftTrayItem>
                            <LeftTrayItem title={translate('maintenanceMeasure.planYearRemarks')}>
                                {props.maintenanceMeasure.planYearRemarks}
                            </LeftTrayItem>
                            <LeftTrayItem title={translate('maintenanceMeasure.scheduledYear')}>
                                {props.maintenanceMeasure.scheduledYear}
                            </LeftTrayItem>
                            <LeftTrayItem title={translate('maintenanceMeasure.scheduledYearRemarks')}>
                                {props.maintenanceMeasure.scheduledYearRemarks}
                            </LeftTrayItem>
                            {props.maintenanceMeasure.location && (
                                <LeftTrayItem title={translate('common.location')}>{props.maintenanceMeasure.location}</LeftTrayItem>
                            )}
                            {props.maintenanceMeasure.quantity && (
                                <LeftTrayItem title={translate('common.quantity')}>{props.maintenanceMeasure.quantity}</LeftTrayItem>
                            )}
                            {props.maintenanceMeasure.material && (
                                <LeftTrayItem title={translate('common.material')}>
                                    {props.maintenanceMeasure.material.quantity}
                                    <UnitOfMeasurement value={props.maintenanceMeasure.material.quantityUnitOfMeasurement} />{' '}
                                    {props.maintenanceMeasure.material.material}
                                </LeftTrayItem>
                            )}
                        </LeftTrayList>
                    </EditPanelCell>
                </EditPanelRow>
                <EditPanelButtons>
                    {!props.maintenanceMeasure.implementationYear && (
                        <RoleDependent
                            allowed={[Roles.Administrator, Roles.Client]}
                            content={
                                <EditPanelButton
                                    onClick={() => {
                                        if (window.confirm(translate('maintenanceMeasure.closeQuestion'))) {
                                            props.setImplementationYear(props.maintenanceMeasure.id);
                                            props.onClose();
                                        }
                                    }}
                                    small={true}
                                    text={translate('maintenanceMeasure.close')}
                                />
                            }
                        />
                    )}
                    <EditPanelButton onClick={() => props.onClose()} small={true} primary={true} text={translate('common.close')} />
                </EditPanelButtons>
            </PanelBodyHeading>
        </PanelWithoutForm>
    );
}
